// extracted by mini-css-extract-plugin
export default {"container":"QuoteMap_container__ePzXx"};